import React, { useState, useCallback } from "react";
import BG_IMAGE from "../../assets/BgOverlayImage.jpeg";
import { stripHtml } from "../../utils/util-functions/stripHTML";
import { stripText } from "../../utils/util-functions/stripText";
import { toast } from "sonner";
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "../../components/ui/hover-card";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { BadgeInfo, Copy } from "lucide-react";

const OfferCard = ({
  code,
  description,
  flat_discount_amount,
  title,
  offer_discount,
  width = "w-full",
  description_limit = 150
}) => {
  const [promoCode, setPromoCode] = useState(code);
  const [copied, setCopied] = useState(false);

  const onCopy = useCallback(() => {
    setCopied(true);
  }, []);
  return (
    <div
      style={{
        backgroundImage: `linear-gradient(to right, rgba(34, 211, 238, 0.8), rgba(147, 51, 234, 0.8)), url('${BG_IMAGE}')`,
        backgroundSize: "cover",
        backgroundPosition: "bottom",
        fontFamily: "DM Sans",
      }}
      className="flex flex-col lg:flex-row justify-between items-start lg:items-center
  lg:h-[12rem] h-auto rounded-3xl gap-3
  px-3 py-3 lg:px-6 lg:py-0
  w-full max-w-full overflow-hidden"
    >
      <div className=" bg-white rounded-full text-cyan-400
  lg:h-[8rem] lg:w-[8rem]
  md:h-[6rem] md:w-[6rem]
  h-[5rem] w-[5rem]
  flex justify-center items-center
  mx-auto lg:ml-4">
        {offer_discount === "0" ? (
          <div className="flex flex-col items-center justify-center text-center leading-tight px-1">
            <div className="font-bold 
    text-sm sm:text-base md:text-xl lg:text-2xl
    whitespace-nowrap">₹ {flat_discount_amount}</div>
            <div className="text-xs sm:text-sm md:text-lg lg:text-xl font-semibold">off</div>
          </div>
        ) : (
          <div className="flex flex-col items-center">
            <div className="lg:text-2xl md:text-xl text-lg font-bold">{offer_discount} %</div>
            <div className="lg:text-xl md:text-lg text-[1rem] font-semibold">off</div>
          </div>
        )}
      </div>
      <div className="w-full lg:w-3/4 ml-0 lg:ml-3">
        <div className="flex items-start gap-2 text-white flex-wrap">
          <HoverCard>
            <HoverCardTrigger>
              <span>
                <BadgeInfo className="cursor-pointer mr-2 lg:mr-4 flex-shrink-0" />
              </span>
            </HoverCardTrigger>
            <HoverCardContent className="max-w-[90vw] w-full lg:w-[30rem] break-words">
              {stripHtml(description)}
            </HoverCardContent>
          </HoverCard>
          <div className="font-semibold lg:text-2xl text-lg break-words">{title}</div>
        </div>

        <div className="text-white my-2 lg:text-[1rem] text-sm">
          {stripText(stripHtml(description), description_limit)}
        </div>
        <div className="flex flex-wrap text-white items-center gap-2">
          <span className="font-bold border-2 border-white border-dashed
  lg:rounded-xl rounded-lg
  lg:px-2 lg:py-1 px-1.5 py-0.5
  lg:text-xl text-sm
  break-all max-w-full">
            {code}
          </span>
          <CopyToClipboard onCopy={onCopy} text={promoCode}>
            <button
              className="ml-2 cursor-pointer"
              onClick={() =>
                toast(`Promo ${promoCode} copied to Clipboard ✅`)
              }
            >
              <Copy />
            </button>
          </CopyToClipboard>
        </div>
      </div>
    </div>
  );
};

export default OfferCard;
